import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Radio from '@strava/ui/Radio';
import I18n from 'utils/I18n';

import BaseModal from '../BaseModal';

import styles from './styles.scss';

const ReportPhotoModal = ({
  isOpen,
  isReported,
  isReporting,
  onDismiss,
  onSubmit
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  const optionInappropriate = 'inappropriate';
  const optionCopyright = 'copyright';
  const optionHarassment = 'harassment';
  const optionNoConsent = 'no_consent';

  const labelStyles = {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center'
  };

  const handleOnDismiss = () => {
    setSelectedOption('');
    onDismiss();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(selectedOption);
    setSelectedOption('');
  };

  return (
    <BaseModal
      isOpen={isOpen}
      hasChanges={selectedOption !== ''}
      isSaving={isReporting}
      buttonLabels={{
        savingText: I18n.t('templates.feed.activity.report_photo.submitting'),
        saveText: I18n.t('templates.feed.activity.report_photo.submit')
      }}
      onDismiss={handleOnDismiss}
      onSubmit={handleSubmit}
      title={I18n.t('templates.feed.activity.report_photo.title')}
      hideSaveBtn={isReported}
    >
      {isReported && (
        <div className={styles.reportedPhotoMessage}>
          {I18n.t('templates.feed.activity.report_photo.report_success')}
        </div>
      )}

      {!isReported && (
        <>
          <label htmlFor={optionInappropriate} style={labelStyles}>
            <Radio
              id={optionInappropriate}
              name="report-options"
              value={optionInappropriate}
              checked={selectedOption === optionInappropriate}
              onChange={() => setSelectedOption(optionInappropriate)}
            />
            <span className={styles.labelValue}>
              {I18n.t(
                'templates.feed.activity.report_photo.inappropriate_content.header'
              )}
            </span>
            <span className={styles.labelExample}>
              {I18n.t(
                'templates.feed.activity.report_photo.inappropriate_content.examples'
              )}
            </span>
          </label>

          <label htmlFor={optionCopyright} style={labelStyles}>
            <Radio
              id={optionCopyright}
              name="report-options"
              value={optionCopyright}
              checked={selectedOption === optionCopyright}
              onChange={() => setSelectedOption(optionCopyright)}
            />
            <span className={styles.labelValue}>
              {I18n.t(
                'templates.feed.activity.report_photo.copyright_complaint.header'
              )}
            </span>
            <span className={styles.labelExample}>
              {I18n.t(
                'templates.feed.activity.report_photo.copyright_complaint.examples'
              )}
            </span>
          </label>

          <label htmlFor={optionHarassment} style={labelStyles}>
            <Radio
              id={optionHarassment}
              name="report-options"
              value={optionHarassment}
              checked={selectedOption === optionHarassment}
              onChange={() => setSelectedOption(optionHarassment)}
            />
            <span className={styles.labelValue}>
              {I18n.t('templates.feed.activity.report_photo.harassment')}
            </span>
          </label>

          <label htmlFor={optionNoConsent} style={labelStyles}>
            <Radio
              id={optionNoConsent}
              name="report-options"
              value={optionNoConsent}
              checked={selectedOption === optionNoConsent}
              onChange={() => setSelectedOption(optionNoConsent)}
            />
            <span className={styles.labelValue}>
              {I18n.t(
                'templates.feed.activity.report_photo.no_consent_from_me'
              )}
            </span>
          </label>
        </>
      )}
    </BaseModal>
  );
};

ReportPhotoModal.propTypes = {
  isOpen: PropTypes.bool,
  isReported: PropTypes.bool,
  onDismiss: PropTypes.func,
  onSubmit: PropTypes.func,
  isReporting: PropTypes.bool
};

ReportPhotoModal.defaultProps = {
  isOpen: false,
  isReported: false,
  onDismiss: () => {},
  onSubmit: () => {},
  isReporting: false
};

export default ReportPhotoModal;
